module.exports = __webpack_public_path__ + "static/2-c8144b6e8e6cb714e025c86975ef653c.jpg";